import isEqual from 'lodash/isEqual';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Container } from 'unstated';

type PageTreeStateUpdaterStateType = {
	highlightPagesIds: string[];
	forceFetchPageId: string | null;
	optimisticDeletePageId: string | null;
	scrollToCurrent: boolean;
	scrollToPageId: string | null;
	editingTitle: {
		contentId: string | null;
		isNewContent?: boolean;
	};
};

export class PageTreeStateUpdater extends Container<PageTreeStateUpdaterStateType> {
	state: PageTreeStateUpdaterStateType = {
		highlightPagesIds: [],
		forceFetchPageId: null,
		optimisticDeletePageId: null,
		scrollToCurrent: false,
		scrollToPageId: null,
		editingTitle: { contentId: null },
	};

	scrollToCurrentPage(): void {
		void this.setState({ scrollToCurrent: true });
	}

	clearScrollTo(): void {
		void this.setState({ scrollToCurrent: false });
	}

	setHighlightPagesIds(pageIds: string[]): void {
		if (!isEqual(this.state.highlightPagesIds, pageIds)) {
			void this.setState({ highlightPagesIds: pageIds });
		}
	}

	clearHighlightedPages(): void {
		this.setHighlightPagesIds([]);
	}

	setForceFetchPageId(pageId: any): void {
		void this.setState({ forceFetchPageId: pageId });
	}

	clearForceFetch(): void {
		this.setForceFetchPageId(null);
	}

	setOptimisticDeleteId(pageId: any): void {
		void this.setState({ optimisticDeletePageId: pageId });
	}

	clearOptimisticDeleteId(): void {
		this.setOptimisticDeleteId(null);
	}

	setIsEditingTitleId(contentId: any): Promise<void> {
		return this.setState({ editingTitle: { contentId } });
	}

	// This is for content types such as folders that do not have a create content url
	// Instead, we allow naming the content inside the page tree immediately after creation
	forceFetchWithInlineRename(forceFetchId: any, contentId: any): void {
		void this.setState({
			forceFetchPageId: forceFetchId,
			editingTitle: {
				contentId,
				isNewContent: true,
			},
			scrollToPageId: contentId,
		});
	}

	clearScrollToPageId(): void {
		void this.setState({ scrollToPageId: null });
	}
}
